import React from "react";
import EditableText from "../edit/EditableText";
import PageCopyright from "../edit/PageCopyright";
import { PAGE_TITLE_STYLE } from "../edit/textStyles";
import DECLARATION_SECTIONS from "./declarationSections";

function DeclarationPage() {
  return (
    <div className="main-content" style={{ maxWidth: 900, margin: "0 auto", padding: 24 }}>
      <EditableText id="declaration.title" defaultContent="信仰宣言" defaultStyle={PAGE_TITLE_STYLE} />
      <EditableText
        id="declaration.intro"
        as="h3"
        defaultContent="生命河教会的信仰宣言是基于2000年浸信会信仰和信息。文本对浸信会信仰和信息的中文翻译作些修改。"
        defaultStyle={{ textAlign: "center", color: "#0693e3", marginBottom: "32px" }}
      />
      {DECLARATION_SECTIONS.map((section) => (
        <section
          key={section.id}
          style={
            section.alt
              ? { background: "#f0f5fa", borderRadius: 8, padding: 16, marginBottom: 32 }
              : { marginBottom: 32 }
          }
        >
          <EditableText
            id={`declaration.${section.id}.title`}
            as="h4"
            defaultContent={section.title}
          />
          <EditableText id={`declaration.${section.id}.body`} defaultContent={section.body} />
        </section>
      ))}
      <PageCopyright pageId="declaration" />
    </div>
  );
}

export default DeclarationPage;
